export default __webpack_public_path__ + "static/media/IUSD+_old.2c88d249.png";